export const genderOptions = [
    "Male",
    "Female",
    "Non-binary",
    "Undisclosed",
];
export const genderFormOptions = [
    "Male",
    "Female",
    "Non-binary",
    "Prefer not to say",
];
//# sourceMappingURL=gender.js.map